interface BuildSearchPageUrlParams {
  query?: string;
  sectionUid?: string | number;
}

interface GoToSearchPageParams {
  searchQuery: string;
  push: (url: string) => void;
  addToHistory?: (query: string) => void;
  onBeforeNavigate?: () => void;
}

export const parseHrefSearchParam = (href: string, param: string): string | null => {
  const index = href.indexOf('?');
  const query = index === -1 ? (href.startsWith('?') ? href : '') : href.slice(index);

  return new URLSearchParams(query).get(param);
};

export const buildSearchPageUrl = ({ query, sectionUid }: BuildSearchPageUrlParams) => {
  const normalizedQuery = query?.trim() ?? '';
  const searchParams = new URLSearchParams();

  if (normalizedQuery) {
    searchParams.set('q', normalizedQuery);
  }

  if (sectionUid !== undefined && sectionUid !== null && sectionUid !== '') {
    searchParams.set('f', `category=${sectionUid}`);
  }

  const queryString = searchParams.toString();

  return queryString ? `/search?${queryString}` : '/search';
};

export const goToSearchPage = ({
  searchQuery,
  push,
  addToHistory,
  onBeforeNavigate
}: GoToSearchPageParams) => {
  const normalizedQuery = searchQuery.trim();
  if (!normalizedQuery) return;

  addToHistory?.(normalizedQuery);
  onBeforeNavigate?.();
  push(buildSearchPageUrl({ query: normalizedQuery }));
};
